/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ActionType {
  LEARN = 'LEARN',
  MEDITATE = 'MEDITATE',
  MOVE = 'MOVE',
}

export enum ArticleType {
  ARTICLE = 'ARTICLE',
  AUDIO = 'AUDIO',
  LIVE = 'LIVE',
  POSE = 'POSE',
  VIDEO = 'VIDEO',
}

export enum ContentGroupType {
  CAROUSEL = 'CAROUSEL',
}

export enum CourseAccessType {
  A_LA_CARTE = 'A_LA_CARTE',
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
  SUBSCRIBED = 'SUBSCRIBED',
}

export enum CourseModuleType {
  ARTICLE = 'ARTICLE',
  AUDIO = 'AUDIO',
  LIVE = 'LIVE',
  PDF = 'PDF',
  QUIZ = 'QUIZ',
  VIDEO = 'VIDEO',
}

export enum CourseType {
  CHALLENGE = 'CHALLENGE',
  PODCAST = 'PODCAST',
  PREMIUM_TRAINING = 'PREMIUM_TRAINING',
  WORKSHOP = 'WORKSHOP',
}

export enum Language {
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH',
}

/**
 * Using title case here to maintain case used in external marketing services
 * In general, enums should be SCREAMING_SNAKE_CASE
 * NOTE: `Digital` is our internal name for the user-facing term `Basic`
 */
export enum MembershipTier {
  Digital = 'Digital',
  Free = 'Free',
  Premium = 'Premium',
}

export enum PracticeType {
  DEFAULT = 'DEFAULT',
  PRANAYAMA = 'PRANAYAMA',
}

export enum SaleValueType {
  PERCENTAGE = 'PERCENTAGE',
}

export enum TemplateStringType {
  CHECKOUT = 'CHECKOUT',
}

export enum ZoomType {
  MEETING = 'MEETING',
  WEBINAR = 'WEBINAR',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
